'use strict';

angular.module('ClinicApp').directive('membershipInfoCard', function(OpencareConstants) {
  return {
    templateUrl: '/views/directives/_membership-info-card.html',
    scope: {
      membership: '=',
      activeMembershipPlan: '=',
    },
    link: function($scope) {
      const plans = Object.values(OpencareConstants.clinicMembership.plan);
      const activePlanIndex = plans.indexOf($scope.activeMembershipPlan);
      const thisPlanIndex = plans.indexOf($scope.membership.plan);

      $scope.isActive = $scope.membership.plan === $scope.activeMembershipPlan;
      $scope.showBanner = thisPlanIndex === activePlanIndex + 1;
      $scope.showCta = activePlanIndex < thisPlanIndex;
    },
  };
});
